export default "__VITE_ASSET__f46058ca__"